import { render } from "./EstimationStepsSection.vue?vue&type=template&id=45355785&ts=true"
import script from "./EstimationStepsSection.vue?vue&type=script&lang=ts"
export * from "./EstimationStepsSection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__